import { createContext, useContext, useState } from 'react';
import { SupplierContextType, SupplierRegisterInput } from './types';

const DEFAULT_VALUE = {
  supplierData: {
    supplier: {
      personId: 0,
      personName: '',
      cnpj: '',
      riskClassification: {
        key: '',
        value: ''
      },
      annualBilling: 0,
      creditLimit: 0,
      socialCapital: 0,
      minApprovalSignatures: 0,
      constitutionDate: '',
      companyType: {
        key: 0,
        value: ''
      },
      companySize: {
        key: 0,
        value: ''
      },
      receitaRegistrationStatus: {
        key: '',
        value: ''
      }
    },
    assignors: [],
    banksDetails: [],
    personIdOperation: 0
  },
  setSupplierData: () => {}
};

export const SupplierContext = createContext<SupplierContextType>({} as SupplierContextType);

export const useSupplierRegister = () => {
  const [supplierData, setSupplierData] = useState<SupplierRegisterInput>(DEFAULT_VALUE.supplierData);
  const [hasChanges, setHasChanges] = useState(false);

  const resetSupplierData = () => {
    setSupplierData(DEFAULT_VALUE.supplierData);
    setHasChanges(false);
  };

  return { supplierData, setSupplierData, hasChanges, setHasChanges, resetSupplierData };
};

export const useSupplierContext = () => {
  const context = useContext(SupplierContext);
  if (!context.supplierData) throw Error('useSupplierContext usado fora de um provider!');
  return context;
};
